import React from 'react';
import { EmailBlock } from '../types';
import {
  TextBlock,
  ImageBlock,
  ButtonBlock,
  DividerBlock,
  SpacerBlock,
  SocialBlock,
  HtmlBlock,
  RowBlock,
  ColumnBlock,
  HeaderBlock,
  FooterBlock
} from '../blocks';

interface BlockRendererProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const BlockRenderer: React.FC<BlockRendererProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const commonProps = {
    block,
    isSelected,
    onSelect,
    isDarkMode
  };

  switch (block.type) {
    case 'text':
      return <TextBlock {...commonProps} />;
    case 'image':
      return <ImageBlock {...commonProps} />;
    case 'button':
      return <ButtonBlock {...commonProps} />;
    case 'divider':
      return <DividerBlock {...commonProps} />;
    case 'spacer':
      return <SpacerBlock {...commonProps} />;
    case 'social':
      return <SocialBlock {...commonProps} />;
    case 'html':
      return <HtmlBlock {...commonProps} />;
    case 'row':
      return <RowBlock {...commonProps} />;
    case 'column':
      return <ColumnBlock {...commonProps} />;
    case 'header':
      return <HeaderBlock {...commonProps} />;
    case 'footer':
      return <FooterBlock {...commonProps} />;
    default:
      return <div>Unknown block type: {block.type}</div>;
  }
};
